import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@gonka-wallet/ui-tokens';
import { openWalletDb, saveSettings } from '@gonka-wallet/storage';
import { TermsModal } from '../components/TermsModal.js';
import { LogoTile } from '../components/LogoTile.js';
import { useSettingsStore } from '../stores/settingsStore.js';
import { useWatchedModalStore } from '../stores/watchedModalStore.js';

export function Welcome() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const termsAcceptedAt = useSettingsStore((s) => s.termsAcceptedAt);
  const setPartial = useSettingsStore((s) => s.setPartial);
  const openWatchedModal = useWatchedModalStore((s) => s.open);
  const [showTerms, setShowTerms] = useState(false);

  useEffect(() => {
    if (!termsAcceptedAt) setShowTerms(true);
  }, [termsAcceptedAt]);

  async function acceptTerms() {
    const db = await openWalletDb();
    const saved = await saveSettings(db, {
      termsAcceptedAt: new Date().toISOString(),
    });
    setPartial(saved);
    setShowTerms(false);
  }

  return (
    <div className="flex min-h-screen flex-col justify-between gap-6 bg-bg px-5 pb-6 pt-4 text-text-primary">
      <div className="flex flex-1 flex-col items-center justify-center gap-8 text-center">
        <LogoTile size={96} />
        <div>
          <div className="text-[34px] font-semibold leading-[1.1] tracking-[-1px] text-text-primary">
            {t('app.name')}
          </div>
          <div className="mt-4 max-w-xs text-[15px] leading-[1.5] text-text-secondary">
            {t('app.taglineLine1')}
            <br />
            {t('app.taglineLine2')}
          </div>
          <div className="mt-5 font-mono text-[11px] leading-[1.55] text-text-tertiary">
            [ {t('welcome.nonCustodialLabel')} ]
            <br />
            {t('welcome.nonCustodialHint')}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2.5">
        <Button variant="primary" onClick={() => navigate('/create')} fullWidth>
          {t('welcome.createNew')}
        </Button>
        <Button variant="secondary" onClick={() => navigate('/import')} fullWidth>
          {t('welcome.importExisting')}
        </Button>
        <button
          type="button"
          className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-border-strong bg-transparent px-6 py-3 text-sm font-medium text-text-primary transition-colors duration-fast ease-press hover:bg-surface-1 active:scale-[0.97]"
          onClick={openWatchedModal}
        >
          <span className="text-base">◎</span>
          {t('welcome.monitorOnly')}
        </button>
      </div>
      {showTerms && <TermsModal onAccept={acceptTerms} />}
    </div>
  );
}
